<template>
  <div :class="[length-1 == index ? '':'device-group-tags-box']">
    <div class="facilities-category">{{category}}</div>
    <ul class="facilities-list">
      <li v-for="item in facilities" :key="item.id">
        <img :src="item.icon" :onerror="defaultImg"/>
        <div>{{getName(item.name)}}<span v-if="item.isFeature" class="is-characteristic"></span><img style="width: 38px;height: 11px;margin-left: 3px;" :src="item.tag" v-if="item.tag" :onerror="defaultImg"/></div>
        
        <div class="common-clr"></div>
      </li>
    </ul>
    <div class="common-clr"></div>
  </div>
</template>

<script>
export default {
  name: "DeviceGroupTags",
  props: {
    category: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: 0
    },
    length: {
      type: Number,
      default: 0
    },
    facilities: {
      type: Array,
      default: null
    }
  },
  computed: {
    defaultImg() {
      return "this.src = 'https://resource.rcclchina.com.cn/common/default/icon-default.png'"
    }
  },
  methods: {
    getName(name) {
      return name.lastIndexOf('-') >= 0 ? name.substr(0, name.lastIndexOf('-')) : name;
    }
  }
}
</script>

<style lang="less" scoped>
.device-group-tags-box{
  border-bottom: 1px solid #EEEEEE;
  box-sizing: border-box;
}
.facilities-category {
  font-size: 14px;
  margin: 10px 0 10px;
  color: #333333;
}
.facilities-list {
  font-size: 12px;
  color: #747d80;
  display: flex;
  flex-wrap: wrap;
  & > li {
    flex-direction: column;
    width: 33.33%;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding-right: 10px;
    position: relative;
    min-height: 14px;
    & > img {
      float: left;
      height: 11px;
      width: 11px;
      margin-right: 4px;
    }
    & > div {
      overflow: hidden;
      margin-top: -1px;
      line-height: 14px;
      word-wrap: break-word;
      word-break: normal;
    }
    & .is-characteristic {
      //font-size: 12px;
      //margin-left: 4px;
      //color: #0173BC;
      display: inline-block;
      height: 5px;
      width: 5px;
      border-radius: 5px;
      margin-left: 3px;
      margin-bottom: 2px;
      background-color: #0173BC;
    }
  }
}
</style>